import { render } from "./TaskDetailDialog.vue?vue&type=template&id=5f7f074f&scoped=true"
import script from "./TaskDetailDialog.vue?vue&type=script&lang=js"
export * from "./TaskDetailDialog.vue?vue&type=script&lang=js"

import "./TaskDetailDialog.vue?vue&type=style&index=0&id=5f7f074f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7f074f"]])

export default __exports__